import React, { FunctionComponent, SVGProps } from 'react';

import { Label } from '../label/label';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './card.scss';

type CardFrontProps = {
  title: string;
  label: string;
  labelColor: string;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
};

export const CardFront: React.FC<CardFrontProps> = ({ label, labelColor, title, icon: IconComponent }) => {
  return (
    <div className="bd-card__front">
      <div className="bd-card__front__text">
        <Label color={labelColor}>
          <Translate id={label} />
        </Label>
        <Title level="5" weight="bold" className="bd-card__front__title">
          <Translate id={title} />
        </Title>
      </div>
      {IconComponent && <IconComponent className="bd-card__front__icon" />}
    </div>
  );
};
